import { render, staticRenderFns } from "./ViewOrderLog.vue?vue&type=template&id=4a8c7e1e"
import script from "./ViewOrderLog.vue?vue&type=script&lang=js"
export * from "./ViewOrderLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a8c7e1e')) {
      api.createRecord('4a8c7e1e', component.options)
    } else {
      api.reload('4a8c7e1e', component.options)
    }
    module.hot.accept("./ViewOrderLog.vue?vue&type=template&id=4a8c7e1e", function () {
      api.rerender('4a8c7e1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/ViewOrderLog.vue"
export default component.exports